import type { LucideIcon } from 'lucide-react';
import { FileCode, FileSpreadsheet, FileText, Image } from 'lucide-react';

export type SeedFile = {
  id: string;
  name: string;
  meta: string;
  Icon: LucideIcon;
  folder: string;
  updatedAt: number;
};

export type SeedArtifactKind = 'document' | 'code';

export type SeedArtifact = {
  id: string;
  name: string;
  meta: string;
  updatedAt: number;
  kind: SeedArtifactKind;
  language?: string;
  version: number;
  previewContent: string;
  codeContent: string;
};

const now = Date.now();
const hour = 60 * 60 * 1000;
const day = 24 * hour;

export const SEED_FILE_FOLDERS = ['Uploads', 'Generated', 'Shared'] as const;

export const SEED_FILES: SeedFile[] = [
  {
    id: 'file-1',
    name: 'Product brief.pdf',
    meta: '2.4 MB · PDF',
    Icon: FileText,
    folder: 'Uploads',
    updatedAt: now - 2 * hour,
  },
  {
    id: 'file-2',
    name: 'Architecture notes.md',
    meta: '18 KB · Markdown',
    Icon: FileCode,
    folder: 'Uploads',
    updatedAt: now - 5 * hour,
  },
  {
    id: 'file-3',
    name: 'Sprint board.xlsx',
    meta: '640 KB · Spreadsheet',
    Icon: FileSpreadsheet,
    folder: 'Shared',
    updatedAt: now - 1 * day,
  },
  {
    id: 'file-4',
    name: 'Wireframe-v2.png',
    meta: '1.1 MB · Image',
    Icon: Image,
    folder: 'Generated',
    updatedAt: now - 2 * day,
  },
  {
    id: 'file-5',
    name: 'Meeting transcript.txt',
    meta: '42 KB · Text',
    Icon: FileText,
    folder: 'Shared',
    updatedAt: now - 3 * day,
  },
];

export const SEED_ARTIFACTS: SeedArtifact[] = [
  {
    id: 'art-1',
    name: 'Status summary',
    meta: 'Document · MD',
    updatedAt: now - 2 * hour,
    kind: 'document',
    version: 2,
    previewContent:
      '# Status summary\n\n## Highlights\n\n- Chat rail parity shipped with markdown turns and tool rows.\n- SharePoint browse modal wired for attach flows.\n- Files library tabs split Files vs Artifacts.',
    codeContent:
      '# Status summary\n\n## Highlights\n\n- Chat rail parity shipped with markdown turns and tool rows.\n- SharePoint browse modal wired for attach flows.\n- Files library tabs split Files vs Artifacts.',
  },
  {
    id: 'art-2',
    name: 'Connector checklist',
    meta: 'Code · TSX',
    updatedAt: now - 1 * day,
    kind: 'code',
    language: 'tsx',
    version: 3,
    previewContent: 'Interactive checklist component with connector toggles.',
    codeContent:
      'export function ConnectorChecklist() {\n  return (\n    <ul className="space-y-2">\n      <li>GitHub — connected</li>\n      <li>Notion — pending auth</li>\n      <li>SharePoint — connected</li>\n    </ul>\n  );\n}',
  },
  {
    id: 'art-3',
    name: 'Onboarding draft',
    meta: 'Document · MD',
    updatedAt: now - 3 * day,
    kind: 'document',
    version: 1,
    previewContent:
      '# Onboarding draft\n\nWelcome to the mock foundation. Start from **modules/overview** and copy the Scene + transform pattern.',
    codeContent:
      '# Onboarding draft\n\nWelcome to the mock foundation. Start from **modules/overview** and copy the Scene + transform pattern.',
  },
];
